<template>

  <v-menu
      ref="menu1"
      v-model="menuQuarterPicker"
      :readonly="readonly"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="290px"
      max-width="300px">
    <template v-slot:activator="{ on }">
      <ValidationProvider v-slot="{ errors }" :name="`'${label}'`" :rules="rules" :vid="vid">
        <v-text-field
            v-model="formattedData"
            :error="hasErrors"
            :label="label"
            :dense="dense"
            prepend-icon="event"
            readonly
            :error-messages="errors"
            :append-icon="!readonly && (value.quarter || value.year) && !menuQuarterPicker
              ? 'clear'
              : null"
            v-on="on"
            @click:append="clear">
          <template v-if="required" v-slot:prepend-inner>
            <v-icon
                small
                left
                :color="requiredColor">
              *
            </v-icon>
          </template>
        </v-text-field>
      </ValidationProvider>
    </template>
    <v-card class="pa-3">
      <v-row>
        <v-col cols="12">
          <ValidationObserver ref="year">
            <ValidationProvider v-slot="{ errors }" :name="`'${$t('Год')}'`" rules="required" :vid="vid">
              <v-combobox
                  v-model="quarter.year"
                  :error-messages="errors"
                  :label="$t('Год')"
                  :items="years" />
            </ValidationProvider>
          </ValidationObserver>
        </v-col>
        <v-col v-for="q in quarters" :key="q.number" cols="6">
          <v-btn
              :color="q.number === quarter.quarter ? 'primary' : null"
              @click.stop="quarterSelected(q.number)">
            {{ q.text }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-menu>
</template>

<script>
  export default {
    props: {
      value: {
        required: true
      },
      readonly: {
        type: Boolean,
        default: false
      },
      label: String,
      rules: [String, Object],
      required: {
        type: Boolean,
        default: false
      },
      dense: {
        type: Boolean,
        default: false
      },
      requiredColor: {
        type: String,
        default: 'requiredfield'
      },
      vid: {
        type: String,
        default: null
      }
    },
    data () {
      return {
        menuQuarterPicker: false,
        formattedData: null,
        quarter: {
          year: null,
          quarter: null
        }
      }
    },
    computed: {
      hasErrors () {
        return this.errors && this.errors.length > 0
      },
      quarters () {
        const quarters = [1, 2, 3, 4]
        return quarters.map(number => ({ number, text: `${this.$t('квартал')} ${number}` }))
      },
      years () {
        const thisYear = Number.parseInt(this.$moment().format('YYYY'))
        const selected = this.quarter.year || Number.parseInt(this.$moment().format('YYYY'))
        const start = thisYear < selected ? thisYear - 15 : selected - 15
        const end = thisYear > selected ? thisYear + 5 : selected + 5
        const years = []
        let year = start
        while (year <= end) {
          years.push(year)
          year++
        }
        return years
      }
    },
    watch: {
      value: {
        immediate: true,
        deep: true,
        handler (newValue) {
          if (newValue.year !== this.quarter.year ||
            newValue.quarter !== this.quarter.quarter) {
            this.quarter.year = newValue.year
              ? Number.parseInt(newValue.year)
              : Number.parseInt(this.$moment().format('YYYY'))
            this.quarter.quarter = newValue.quarter
              ? Number.parseInt(newValue.quarter)
              : null
            this.formattDisplayValue(this.quarter)
          }
        }
      }
    },
    methods: {
      formattDisplayValue: function (quarter) {
        this.formattedData = quarter.quarter && quarter.year
          ? `${quarter.year} - ${this.$t('квартал')} ${quarter.quarter}`
          : null
      },
      quarterSelected: async function (quarter) {
        const result = await this.$refs.year.validate()
        if (!result) {
          return
        }
        this.quarter.quarter = quarter

        this.updateValue()
      },
      updateValue: function () {
        if (!this.quarter.quarter) {
          return
        }
        this.formattDisplayValue(this.quarter)
        // информируем родительский компонент, что дата поменялась, для запуска самописной обработки
        this.$emit('change', this.quarter)
        this.menuQuarterPicker = false
      },
      clear: function () {
        this.quarter.quarter = null
        this.quarter.year = null

        this.$emit('change', this.quarter)
        this.formattDisplayValue(this.quarter)
      }
    }
  }
</script>
